import { autoinject } from 'aurelia-framework';
import * as moment from 'moment';
import { FormattingHelper } from '../../../helpers/formatting-helper';
import { State } from '../../../services/global-state';
import { PayrazrService } from '../../../services/payrazr';
import { ValidationHelpers } from '../../../services/validation-helpers';
import { I18N } from 'aurelia-i18n';

@autoinject
export class CardFormData {
	payrazr: PayrazrService;
	cardNumber: any;
	expMonth: any;
	expYear: any;
	cvv: any;
	customFields: any;
	showCvv: any;
	isRehabForm: any;
	cvvRequired: any;
	portfolioName: any;
	_cvvLabel: any;
	merchantKey:any;

	constructor(payrazrService: PayrazrService, private i18n: I18N) {
		this.payrazr = payrazrService;
		let today = new Date();
		this.cardNumber = "";
		this.expMonth = (today.getMonth() + 1).toString();
		this.expYear = (today.getFullYear()).toString();
		this.cvv = "";
		this.customFields = [];

		this.showCvv = true;
		this.isRehabForm = false; //todo: is this used?
	}

	checkExpirationDate() {
		let now = moment();
		let exp: any = "";
		var expMonth = this.expMonth;
		if (expMonth == 12) {
			exp = moment({ y: this.expYear, M: 11, d: 31 }).endOf('day');
		} else {
			exp = moment({ y: this.expYear, M: expMonth, d: 1 }).subtract(1, 'seconds');
		}
		return exp >= now;
	}

	validate(errors) {
		let returnedPromise;

		if (this.cardNumber.length === 0) {
			errors.push(this.i18n.i18next.t('cardNumberRequired', 'Card number is required'));
		} else if (!ValidationHelpers.isOnlyDigits(this.cardNumber)) {
			errors.push(this.i18n.i18next.t('cardNumberCanOnlyContainDigits', 'Card number can only contain digits'));
		} else if (this.cardNumber.length < 15 || this.cardNumber.length > 19) {
			errors.push(this.i18n.i18next.t('cardNumberMustBeBetweenFifteenAndNineteenDigits', 'Card number must be between 15 and 19 digits'));
		} else if (!ValidationHelpers.isValidCreditCardNumber(this.cardNumber)) {
			errors.push(this.i18n.i18next.t('cardNumberNotValid', 'Card number is not valid'));
		} else if (!this.checkExpirationDate()) {
			errors.push(this.i18n.i18next.t('cardExpired', 'Card is expired'));
		} else if (this.showCvv && this.cvvRequired) {
			if (this.cvv.length === 0) {
				errors.push(this.i18n.i18next.t('cardSecurityCodeRequired', 'Card security code is required'));
			} else if (this.cvv.length > 4) {
				errors.push(this.i18n.i18next.t('invalidCardSecurityCode', 'Invalid card security code'));
			} else if (!ValidationHelpers.isOnlyDigits(this.cvv)) {
				errors.push(this.i18n.i18next.t('invalidCardSecurityCode', 'Invalid card security code'));
			}
		}

		// always check credit card type
		if (!this.isRehabForm) {
			if (!this.portfolioName) {
				console.log('Portfolio name is empty in CardFormData');
			}

			if (errors.length == 0) {
				returnedPromise = this.payrazr.checkCardType(this.cardNumber, this.portfolioName, 0, this.merchantKey)
					.then(response => {
						if (!response.isValid) errors.push(response.message);
					});
			}
		}

		for (let ii = 0; ii < this.customFields.length; ++ii) {
			let field = this.customFields[ii];
			if (field.visible && field.required && (!field.value || field.value.length === 0)) {
				var label = field.label || `Custom Field ${ii + 1}`;
				errors.push(`${label} is required`);
			}
		}

		return returnedPromise;
	}

	//TODO: Chris - add computedFrom
	get expirationDate() {
		return this.pad(this.expMonth, 2) + this.pad(this.expYear % 100, 2);
	}

	set cvvLabel(value) {
		if (value) {
			this._cvvLabel = value;
		}
	}

	//TODO: Chris - add computedFrom
	get cvvLabel() {
		return this._cvvLabel || this.i18n.i18next.t('cardSecurityCode', 'Card Security Code');
	}

	//TODO: Chris - add computedFrom
	get description() {
		return `card ending in ***${FormattingHelper.mask(this.cardNumber)}`;
	}

	pad(num, size) {
		var s = "000000000" + num;
		return s.substr(s.length - size);
	}
}

@autoinject
export class CardFormCustomElement {
	readonly years: number[];
	readonly months: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	globalState: State;
	cardData: any;
	cardNumberSettings: any;
	cardNumberLabel: string;
	constructor(globalState: State, private i18n: I18N) {

		let today = new Date();
		this.years = [];
		let thisYear = today.getFullYear();
		for (let i = 0; i < 20; ++i) {
			this.years.push(thisYear + i);
		}
		this.globalState = globalState;
		this.cardNumberLabel = this.i18n.i18next.t('cardNumber', 'Card Number')
	}

	//TODO: Chris - add computedFrom
	get validate() {
		return this.cardData && this.cardData.validate;
	}

	activate(cardData) {
		this.cardData = cardData;

		this.cardNumberSettings = this.globalState.business.portalSettings.fields.cardNumber;
		if (!!this.cardNumberSettings && !this.cardNumberSettings.label) { this.cardNumberSettings.label = this.cardNumberLabel; }
	}
}
